import { fork, takeLatest, call, put, all, select } from "redux-saga/effects";
import {
  fetchExamInstructionRequest,
  fetchExamInstructionSuccess,
  fetchExamInstructionFailure,
  fetchExamQuestionRequest,
  fetchExamQuestionSuccess,
  fetchExamQuestionFailure,
  fetchExamQuestionsListRequest,
  fetchExamQuestionsListSuccess,
  fetchExamQuestionsListFailure,
  saveAnswerRequest,
  saveAnswerSuccess,
  saveAnswerFailure,
  setCurrentQuestionIndex,
  fetchPracticeListSuccess,
  fetchPracticeListFailure,
  fetchPracticeListRequest,
  submitExamRequest,
  submitExamSuccess,
  submitExamFailure,
  saveBookmarkRequest,
  saveBookmarkSuccess,
  saveBookmarkFailure,
} from "./examSlice";
import examApi from "./examApi";
import uiActions from "../../redux/ui/action";

function* fetchExamInstructionWorker(action) {
  try {
    const response = yield call(examApi.getInstruction, action.payload);
    yield put(fetchExamInstructionSuccess(response.data));
  } catch (error) {
    yield put(fetchExamInstructionFailure(error.message));
  }
}

function* fetchExamQuestionWorker(action) {
  try {
    yield put(uiActions.startLoading());
    const { testType, testDetails } = yield select((state) => state.examSlice);
    const response = yield call(examApi.getQuestion, {
      paperType: testType?.id,
      paperId: testDetails?.paper_id,
      ...action.payload,
    });
    yield put(fetchExamQuestionSuccess(response.data));
  } catch (error) {
    yield put(fetchExamQuestionFailure(error.message));
  } finally {
    yield put(uiActions.finishLoading());
  }
}

function* fetchExamQuestionsListWorker(action) {
  try {
    const response = yield call(examApi.getQuestionList, action.payload);
    yield put(fetchExamQuestionsListSuccess(response?.data));

    console.log("response of all questions api", response.data);

    // ✅ Check if the first question exists before calling
    const firstQid = response?.data?.data?.[0]?.qid;
    if (firstQid) {
      yield put(fetchExamQuestionRequest({ qid: firstQid }));
    }
  } catch (error) {
    yield put(fetchExamQuestionsListFailure(error.message));
  }
}

function* saveAnswerWorker(action) {
  try {
    const response = yield call(examApi.saveAnswer, action.payload);
    yield put(saveAnswerSuccess(response));

    const state = yield select((state) => state.examSlice);
    const nextIndex = state.currentQuestionIndex + 1;

    if (state.questionsData[nextIndex]) {
      const nextQid = state.questionsData[nextIndex].qid;
      yield put(
        fetchExamQuestionRequest({
          qid: nextQid,
        })
      );
      yield put(setCurrentQuestionIndex(nextIndex));
    }
  } catch (error) {
    yield put(saveAnswerFailure(error.message));
  }
}

function* fetchPracticeListWorker() {
  try {
    const response = yield call(examApi.getPracticeList);
    yield put(fetchPracticeListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchPracticeListFailure(error.message));
  }
}

function* saveBookmarkWorker(action) {
  try {
    const response = yield call(examApi.saveBookmark, action.payload);
    yield put(saveBookmarkSuccess(response));
  } catch (error) {
    yield put(saveBookmarkFailure(error.message));
  }
}

function* submitExamWorker(action) {
  try {
    const { testType, testDetails } = yield select((state) => state.examSlice);
    const response = yield call(examApi.submitExam, {
      paperType: testType?.id,
      paperId: testDetails?.paper_id,
      ...action.payload,
    });
    yield put(submitExamSuccess(response));
  } catch (error) {
    yield put(submitExamFailure(error.message));
  }
}

function* watchExamSaga() {
  yield takeLatest(
    fetchExamInstructionRequest.type,
    fetchExamInstructionWorker
  );

  yield takeLatest(fetchExamQuestionRequest.type, fetchExamQuestionWorker);
  yield takeLatest(
    fetchExamQuestionsListRequest.type,
    fetchExamQuestionsListWorker
  );
  yield takeLatest(saveAnswerRequest.type, saveAnswerWorker);
  yield takeLatest(saveBookmarkRequest.type, saveBookmarkWorker);
  yield takeLatest(submitExamRequest.type, submitExamWorker);
  yield takeLatest(fetchPracticeListRequest.type, fetchPracticeListWorker);
}

export default function* examSaga() {
  yield all([fork(watchExamSaga)]);
}
